<template>
  <!-- NOTE (TEMPLATE) to show the active proposals -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-modal
      id="fastInviteReviewers"
      ref="fastInviteReviewers"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>دعوت از داور</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-expire) to expiration of the referee -->
            <b-button
              :disabled="busy || selectedReferees.length == 0"
              variant="primary"
              size="lg"
              @click="fastInviteReviewers()"
              >ثبت</b-button
            >

            <!-- NOTE (b-cancel) to cancel expiration -->
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal('fastInviteReviewers')"
              >لغو</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      <b-form-group label="داوران">
        <v-select
          multiple
          :reduce="(x) => x.code"
          :options="referees"
          style="direction: rtl"
          v-model="selectedReferees"
        >
          <template v-slot:option="option">
            <div class="text-right">
              {{ option.label
              }}<b-badge class="m-1 p-1" variant="info"
                >کل {{ option.all }}</b-badge
              ><b-badge class="m-1 p-1" variant="success"
                >انجام شده {{ option.dones }}</b-badge
              ><b-badge class="m-1 p-1" variant="danger"
                >لغو شده {{ option.expireds }}</b-badge
              ><b-badge class="m-1 p-1" variant="warning"
                >در جریان {{ option.ongoings }}</b-badge
              >
            </div>
          </template>
        </v-select>
      </b-form-group>
      <div v-if="selectedReferees.length">
        <div class="mb-2">داوران انتخاب شده</div>
        <div
          class="selected-referees"
          v-for="(item, index) in computedSelectedReferees"
          :key="index"
        >
          <v-card>
            <v-card-title>{{ item.label }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>داوری‌های دعوت شده: {{ item.all }}</v-col>
                <v-col>داوری‌های انجام شده: {{ item.dones }}</v-col>
              </v-row>
              <v-row>
                <v-col>داوری‌های در جریان: {{ item.ongoings }}</v-col>
                <v-col>داوری‌های لغو شده: {{ item.expireds }}</v-col>
              </v-row>
              <v-row v-if="item.tags.length != 0">
                <v-col class="selected-referees__tags">
                  <h6>برچسب‌های داور</h6>
                  <b-badge
                    class="tag"
                    v-for="(tag, index2) in item.tags"
                    :key="index2"
                    variant="primary"
                    >{{ tag }}</b-badge
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </div>

      <div
        class="d-flex flex-row py-2"
        v-if="selectedRequest.commercializingType == 'accelerator'"
      >
        <b-form-checkbox style="margin-right: -8px" v-model="isAccelerator">
        </b-form-checkbox>
        <p class="ml-2">امکان داوری حمایت برای شتاب‌دهنده نیز وجود دارد.</p>
      </div>
      <hr
        class="mt-2"
        v-if="selectedRequest.commercializingType == 'accelerator'"
      />
      <b-form-group label="یادداشت برای داور">
        <b-form-textarea
          trim
          id="textarea"
          aria-describedby="adminToReferee"
          v-model="adminToReferee"
          width="75%"
          rows="8"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group label="نظرات">
        <b-form-textarea
          trim
          id="textarea"
          aria-describedby="description"
          v-model="description"
          width="75%"
          placeholder="نظرات خود را اینجا وارد نمایید"
          rows="8"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>
    </b-modal>
    <b-modal
      id="fastReject"
      ref="fastReject"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>رد سریع حمایت</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-expire) to expiration of the referee -->
            <b-button
              :disabled="busy || rejectCause.length == 0"
              variant="primary"
              size="lg"
              @click="fastReject()"
              >ثبت</b-button
            >

            <!-- NOTE (b-cancel) to cancel expiration -->
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal('fastReject')"
              >لغو</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      <b-form-group label="دلایل رد">
        <v-select
          multiple
          :reduce="(x) => x.code"
          :options="rejectOptions"
          style="direction: ltr"
          v-model="rejectCause"
          class="reject-select"
        >
        </v-select>
      </b-form-group>
      <b-form-group label="نظرات">
        <b-form-textarea
          trim
          id="textarea"
          aria-describedby="description"
          v-model="description"
          width="75%"
          placeholder="نظرات خود را اینجا وارد نمایید"
          rows="8"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>
    </b-modal>
    <b-modal
      id="fastSubmit"
      ref="fastSubmit"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>تایید سریع حمایت</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-expire) to expiration of the referee -->
            <b-button
              :disabled="busy"
              variant="primary"
              size="lg"
              @click="fastSubmit()"
              >تایید</b-button
            >

            <!-- NOTE (b-cancel) to cancel expiration -->
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal('fastSubmit')"
              >لغو</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      <b-form-group label="نظرات">
        <b-form-textarea
          trim
          id="textarea"
          aria-describedby="description"
          v-model="description"
          width="75%"
          placeholder="نظرات خود را اینجا وارد نمایید"
          rows="8"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>
    </b-modal>
    <b-card
      v-if="$router.currentRoute.path == '/admin/todo/corrected'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <p>
        ادمین گرامی؛
        <br />
        حمایت‌های بازبینی شده توسط پژوهشگر در این بخش نمایش داده میشود.
        <br />
        شما میتوانید روی نام هر حمایت کلیک کنید و وارد جزییات آن شوید. همچنین
        میتوانید با کلیک روی گزینه‌های مشخص شده، حمایت را به سرعت پذیرش کنید، آن
        را به سرعت رد کنید یا به منظور آغاز فرآیند داوری، از داوران مورد نظر خود
        دعوت کنید.
      </p>
      <h6>
        <hr />
        <b-button
          @click="
            selectedType = 'all';
            currentPage = 1;
          "
          :variant="selectedType == 'all' ? 'primary' : 'outline-primary'"
          class="m-1"
          >همه ({{ items.length }})</b-button
        >
        <b-button
          v-for="type in types"
          :key="type.key"
          @click="
            selectedType = type.key;
            currentPage = 1;
          "
          :disabled="!items.filter((x) => x.requestType == type.key).length"
          :variant="selectedType == type.key ? 'primary' : 'outline-primary'"
          class="m-1"
          >{{ type.title }} ({{
            items.filter((x) => x.requestType == type.key).length
          }})</b-button
        >
        <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 25px 1px">
          <v-col>
            <h4 style="margin-top: 9px">
              {{ selectedType == "all" ? "همه درخواست‌ها" : selectedType }}
            </h4>
          </v-col>
          <v-col>
            <v-btn
              class="bc-primary text-white btn-radius float-end"
              width="200"
              height="45"
              elevation="0"
              :disabled="isBusy || !computedItems.length"
              @click="$refs.table1.$el.click()"
            >
              <span class="fs-small">
                خروجی اکسل

                <v-icon>$Excel</v-icon></span
              >
            </v-btn>
            <vue-excel-xlsx
              v-show="false"
              ref="table1"
              :data="computedItems"
              :columns="excelFields"
              :filename="
                'لیست حمایت های اصلاح شده (' +
                (selectedType == 'all' ? 'همه درخواست‌ ها' : selectedType) +
                ')'
              "
              :sheetname="currentDate"
            >
              دریافت اکسل
            </vue-excel-xlsx>
          </v-col>
        </v-row>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            class="mt-1"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-activeProposals) to show the active proposals list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="رکوردی برای نمایش وجود ندارد"
        empty-filtered-text="رکوردی برای نمایش وجود ندارد"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(time)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.item.last_update }}
          </div>
        </template>
        <template v-slot:cell(faSubject)="data">
          <div style="text-align: center; vertical-align: middle">
            <a
              v-if="data.item.requestTypeEn == 'project'"
              :href="'/admin/proposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'phd'"
              :href="'/admin/phdProposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'master'"
              :href="'/admin/masterProposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'opportune'"
              :href="'/admin/opportunity/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'elite'"
              :href="'/admin/elite/' + data.item.id"
              target="_blank"
              >نخبه وظیفه</a
            >
            <a
              v-else
              :href="'/admin/' + data.item.requestTypeEn + '/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <b-button
              variant="success"
              @click="openSubmitModal(data.item)"
              class="m-2 text-light"
              >تایید سریع</b-button
            >
            <b-button
              variant="warning"
              @click="openInviteReviewersModal(data.item)"
              class="m-2 text-light"
            >
              دعوت از داور</b-button
            >
            <b-button
              variant="danger"
              @click="openRejectModal(data.item)"
              class="m-2 text-light"
              >رد سریع</b-button
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="selectedType == 'all' ? totalRows : computedItems.length"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  components: {},
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "faSubject", label: "عنوان حمایت" },
        { key: "researcherName", label: "نام پژوهشگر" },
        { key: "requestType", label: "نوع حمایت" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "university", label: "دانشگاه" },
        { key: "version", label: "نسخه" },
        { key: "lastUpdate", label: "آخرین بروزرسانی", sortable: true },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "faSubject", label: "عنوان حمایت" },
        { field: "researcherName", label: "نام پژوهشگر" },
        { field: "requestType", label: "نوع حمایت" },
        { field: "requestsCode", label: "کد طرح" },
        { field: "registerDate", label: "تاریخ ثبت" },
        { field: "university", label: "دانشگاه" },
        { field: "version", label: "نسخه" },
        { field: "lastUpdate", label: "آخرین بروزرسانی", sortable: true },
      ],
      types: [
        { key: "طرح پژوهشی", title: "طرح" },
        { key: "رساله دکتری", title: "رساله دکتری" },
        { key: "پایان نامه کارشناسی ارشد", title: "پایان‌نامه ارشد" },
        { key: "مقاله", title: "مقاله" },
        { key: "فرصت مطالعاتی", title: "فرصت مطالعاتی" },
        { key: "نشست تخصصی", title: "نشست تخصصی" },
        { key: "پسادکتری", title: "پسادکتری" },
        { key: "نخبگان وظیفه", title: "نخبگان وظیفه" },
      ],
      items: [],
      filter: "",
      selectedType: "all",
      isBusy: true,
      busy: false,
      description: "",
      selectedRequest: {},
      rejectCause: [],
      rejectOptions: [],
      referees: [],
      selectedReferees: [],
      adminToReferee: "",
      isAccelerator: false,
    };
  },

  methods: {
    openInviteReviewersModal(item) {
      this.selectedRequest = item;
      this.description = "";
      this.adminToReferee = "";
      this.selectedReferees = [];
      this.showModal("fastInviteReviewers");
    },
    fastInviteReviewers() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/inviteReviewers",
          {
            requestId: this.selectedRequest.id,
            referees: this.selectedReferees,
            adminToReferee: this.adminToReferee,
            description: this.description,
            isAccelerator: this.isAccelerator,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.busy = false;
          this.hideModal("fastInviteReviewers");
          this.onMounted();
        })
        .catch((err) => {
          this.busy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    getReferees() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reviewers/select",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.referees = [];
          this.referees.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
                tags: x.tags,
                all: x.all,
                dones: x.dones,
                ongoings: x.ongoings,
                expireds: x.expireds,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openRejectModal(item) {
      this.selectedRequest = item;
      this.description = "";
      this.rejectCause = [];
      this.showModal("fastReject");
    },
    fastReject() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/reject",
          {
            requestId: this.selectedRequest.id,
            rejectionIds: this.rejectCause,
            description: this.description,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.busy = false;
          this.hideModal("fastReject");
          this.onMounted();
        })
        .catch((err) => {
          this.busy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    rejections() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/rejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.rejectOptions = [];
          this.rejectOptions.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    hideModal(id) {
      // NOTE (m-hideModal) to hide modal
      this.$refs[id].hide();
    },
    showModal(id) {
      // NOTE (m-showModal) to show modal
      this.$refs[id].show();
    },
    openSubmitModal(item) {
      this.selectedRequest = item;
      this.description = "";
      this.showModal("fastSubmit");
    },
    fastSubmit() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/approve",
          {
            requestId: this.selectedRequest.id,
            description: this.description,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.busy = false;
          this.hideModal("fastSubmit");
          this.onMounted();
        })
        .catch((err) => {
          this.busy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      this.isBusy = true;
      // NOTE (MOUNTED) to show the proposals data
      this.$http
        .post(
          this.baseUrl + "/setad/admin/requests/corrected",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },
  computed: {
    computedItems() {
      let filtered = [];
      if (this.selectedType != "all") {
        filtered = this.items.filter((x) => x.requestType == this.selectedType);
      } else {
        filtered = this.items;
      }
      return filtered;
    },
    computedSelectedReferees() {
      let referees = this.referees.filter(
        (x) => this.selectedReferees.indexOf(x.code) != -1
      );
      return referees;
    },
  },
  mounted() {
    if (this.$router.currentRoute.path == "/admin/todo/corrected")
      this.onMounted();
    this.rejections();
    this.getReferees();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../../assets/fonts/IRANSans(FaNum).ttf");
}
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
.reject-select {
  .vs__dropdown-menu {
    direction: rtl !important;
  }
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
